import _ from 'lodash'
import LogRocket from 'logrocket'
import * as Sentry from '@sentry/react';
import { useSelector } from 'react-redux'
import AppSettings from '../config'
import identitySelectors from '../selectors/identity'

export default (props:any) => {
  const [ , site ] = window.location.pathname.split('/')
  const isLoggedIn = useSelector(identitySelectors.isLoggedIn);
  const username = useSelector(identitySelectors.getUserUsername);
  const userId = useSelector(identitySelectors.getUserId);
  const userEmail = useSelector(identitySelectors.getUserEmail);
  const initLogRocket = !_.some([
    !isLoggedIn,
    username === 'govout143',
    userEmail?.endsWith('@gogovapps.com'),
    site.startsWith('test')
  ])
  if(initLogRocket) {
    console.log('Setup LogRocket', site);
    LogRocket.init(AppSettings.LOGROCKET_SLUG);
    LogRocket.identify(`${userId}`, {
      email: userEmail,
      name: userEmail || username,
      site: site
    });
    LogRocket.getSessionURL(sessionURL => {
      Sentry.configureScope(scope => {
        scope.setExtra("sessionURL", sessionURL);
      });
    });
  }
  return (props.children);
}

